import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import useApiFunction from "../../api/useApiFunction";
import valueContext from "../../customHook/useContext";

function Withdrawal() {
  const { joinToken } = useContext(valueContext);
  const token = joinToken();
  const [data, setData] = useState("");
  const [isLoading, setIsLoading] = useState({ pay: false, refund: false });
  const [load, setLoad] = useState(false);
  const [dataStatus, setDataStatus] = useState("");
  const { formDataFunc } = useApiFunction();
  const navigate = useNavigate();
  function SearchStatus(value) {
    if (value == 1 || value == 2 || value == 0) {
      let filter = data?.filter(data => data.status == value);
      setDataStatus(filter);
    } else {
      setDataStatus(data);
    }
  }
  async function Change(id, e) {
    e.target.id == "1"
      ? setIsLoading({ ...isLoading, pay: true })
      : setIsLoading({ ...isLoading, refund: true });
    const type = e.target.id == "1" ? 1 : 2;
    const body = {
      withdrawalId: id,
      type: type
    };

    const res = await formDataFunc(
      "admin/pay-and-refund",
      JSON.stringify(body),
      "POST",
      token
    );
    if (res.status) {
      setLoad(prv => !prv);
      toast.success(res.msg, { autoClose: 2000 });
    } else if (
      res.error &&
      (res.error === "ERROR_TOKEN_INVALID0" ||
        res.error === "ERROR_TOKEN_INVALID1" ||
        res.error === "user not registered" ||
        res.error === "ERROR_TOKEN_INVALID2" ||
        res.error === "ERROR_TOKEN_INVALID3" ||
        res.error === "unauthorized" ||
        res.error === "Your session has expierd Please login again 1" ||
        res.error === "Your session has expierd Please login again 2")
    ) {
      navigate("/admin/login");
    } else if (res.error) {
      toast.warning(res.error, { autoClose: 2000 });
    } else {
      toast.warning(res.msg, {
        autoClose: 2000
      });
    }
    setIsLoading({ refund: false, pay: false });
  }
  async function getWithdrawal() {
    const res = await formDataFunc(
      "admin/get-withdrawal-report",
      JSON.stringify({}),
      "POST",
      token
    );
    if (res.status) {
      setData(res.msg);
      setDataStatus(res.msg);
    } else if (
      res.error &&
      (res.error === "ERROR_TOKEN_INVALID0" ||
        res.error === "ERROR_TOKEN_INVALID1" ||
        res.error === "user not registered" ||
        res.error === "ERROR_TOKEN_INVALID2" ||
        res.error === "ERROR_TOKEN_INVALID3" ||
        res.error === "unauthorized" ||
        res.error === "Your session has expierd Please login again 1" ||
        res.error === "Your session has expierd Please login again 2")
    ) {
      navigate("/admin/login");
    } else if (res.error) {
      toast.warning(res.error, { autoClose: 2000 });
    } else {
      toast.warning(res.msg, {
        autoClose: 2000
      });
    }
  }

  function handleHash(hash) {
    window.open(`https://bscscan.com/tx/${hash}`, "_blank");
  }
  console.log(load);
  useEffect(() => {
    getWithdrawal();
  }, [load]);
  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">Withdrawal</h4>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div className="d-flex justify-content-between">
                        <h4 className="card-title table-head">
                          Withdrawal List
                        </h4>
                        <select
                          name="type"
                          className="level-option  card-title2"
                          onChange={e => SearchStatus(e.target.value)}
                        >
                          {" "}
                          <option value={3}>
                            {" "}
                            &nbsp;&nbsp;All&nbsp;&nbsp;
                          </option>
                          <option value={0}>
                            {" "}
                            &nbsp;&nbsp;Pending&nbsp;&nbsp;
                          </option>
                          <option value={1}>
                            {" "}
                            &nbsp;&nbsp;Success&nbsp;&nbsp;
                          </option>
                          <option value={2}>
                            {" "}
                            &nbsp;&nbsp;Refund&nbsp;&nbsp;
                          </option>
                        </select>
                      </div>
                      <div className="table-responsive table-line">
                        <table
                          className="table align-middle mb-0"
                          id="order-listing"
                        >
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Username</th>
                              <th>Name</th>
                              <th>Amount</th>
                              <th>Deduction (10%)</th>
                              <th>Transfer Amount</th>
                              <th>Address</th>
                              <th>Date</th>
                              <th>Core</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dataStatus && dataStatus?.length > 0 ? (
                              dataStatus.map((details, i) => {
                                let transHash =
                                  details?.transHash?.length > 15
                                    ? `${details?.transHash?.slice(0, 15)}...`
                                    : details?.transHash;
                                return (
                                  <tr>
                                    <th scope="row">{i + 1}</th>
                                    <td>{details.userName}</td>
                                    <td>
                                      {details.member_details?.length > 0
                                        ? details.member_details[0].name
                                        : "-"}
                                    </td>
                                    <td> {details.amount} TLIFE</td>
                                    <td>
                                      {Math.floor(details.deduction * 10000) /
                                        10000}{" "}
                                      TLIFE
                                    </td>
                                    <td>
                                      {Math.floor(
                                        details.trans_amount * 10000
                                      ) / 10000}{" "}
                                      TLIFE
                                    </td>

                                    <td style={{ wordWrap: "wrap" }}>
                                      {details.address}
                                    </td>
                                    <td>{details.date}</td>
                                    <td>
                                      {" "}
                                      {details.member_details.length > 0
                                        ? details.member_details[0].core
                                        : "-"}
                                    </td>
                                    {details.status == 0 && (
                                      <>
                                        <td>
                                          <button
                                            className="btn btn-success btn-sm"
                                            id="1"
                                            onClick={e =>
                                              Change(details._id, e)
                                            }
                                          >
                                            {isLoading.pay && (
                                              <i
                                                className="bx bx-loader-circle rotating"
                                                style={{ marginRight: "5px" }}
                                              />
                                            )}
                                            Pay
                                          </button>
                                        </td>
                                        <td>
                                          <button
                                            className="btn btn-danger btn-sm"
                                            id="2"
                                            onClick={e =>
                                              Change(details._id, e)
                                            }
                                          >
                                            {isLoading.refund && (
                                              <i
                                                className="bx bx-loader-circle rotating"
                                                style={{ marginRight: "5px" }}
                                              />
                                            )}
                                            Refund
                                          </button>
                                        </td>
                                      </>
                                    )}
                                    {details.status == 1 && (
                                      <>
                                        <td>
                                          <span style={{ color: "green" }}>
                                            Success
                                          </span>
                                        </td>
                                        <td
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            handleHash(details.transHash)
                                          }
                                        >
                                          <span
                                            style={{
                                              color: "blue"
                                            }}
                                          >
                                            {transHash}
                                          </span>
                                        </td>
                                      </>
                                    )}
                                    {details.status == 2 && (
                                      <>
                                        <td>
                                          <span style={{ color: "red" }}>
                                            Refunded
                                          </span>
                                        </td>
                                      </>
                                    )}
                                  </tr>
                                );
                              })
                            ) : (
                              <p>NO DATA</p>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default Withdrawal;
